import axios from 'axios'
import Cookies from 'universal-cookie'
// import { logOut } from '../utils/userUtils'

const cookies = new Cookies()

const axiosCommonApi = axios.create({
  baseURL: process.env.REACT_APP_APIS_SERVICE_URL,
  responseType: 'json',
})

axiosCommonApi.defaults.timeout = 60000
axiosCommonApi.defaults.headers.post['Content-Type'] = 'multipart/form-data'

axiosCommonApi.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    const token = cookies.get('access_nhansu_token')
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

axiosCommonApi.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response.data
  },
  function (error) {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      console.log('401 || 403')
    }
    return Promise.reject(error?.response?.data ?? error)
  }
)

export default axiosCommonApi

